exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-container[data-v-f3fb7e6c] {\n  padding: 0 !important;\n  width: 100% !important;\n}\n.v-card[data-v-f3fb7e6c] {\n  width: 100% !important;\n  overflow: hidden;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.v-layout[data-v-f3fb7e6c] {\n  width: 100% !important;\n  margin: 0 !important;\n}\n.v-flex[data-v-f3fb7e6c] {\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.h2_title[data-v-f3fb7e6c] {\n  margin-top: 12px !important;\n}\n", ""]);

// exports
